import React, { Component } from "react";
import {
  Layout,
  Dropdown,
  Menu,
  Icon,
  Row,
  Col,
  Input,
  Tooltip,
  Pagination,
  Spin,
  Popconfirm,
  Button,
} from "antd";
import { Link } from "react-router-dom";
// import Head from "../components/Head";
// import Foote from "../components/Footer";
// import ICP from "../components/ICP";
import default_head from "../../assets/head_default_img.png";
import "../../css/search-result.css";
import { api, app } from "../../app";
import config from "../../config";

const { Header, Content } = Layout;

function NoData(props) {
  return (
    <p className="no_data">
      在<span>{props.search_type_str}</span>中搜索不到与“{" "}
      <span>{props.search_val}</span> ”相关的内容!
    </p>
  );
}

class SearchResult extends Component {
  constructor(props) {
    super(props);
    // const search_type = props.match.params.search_type,
    // search_val = props.match.params.search_val;
    // let search_type_str = "姓名";
    this.state = {
      img:
        config.imgUrl +
        "/Uploads/jiaZheng99krltkerkewrewkrewkrewpkrekrpweewfe.jpg",
      token: "",
      isTrue: false,
      classList: [],
      resultList: [],
      class_loading: false,
      data_loading: false,
      page: 1,
      total: 0,
      search_type_str: "姓名",
      search_type: "searchform_name",
      search_val: "",
      search_val_flag: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.setState({ date: this.props.date });
    this.getTokeni();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  /**
   * 数据集
   * @param search_type
   * @param search_val
   */
  dataSource = (
    page = 1,
    search_type,
    search_val,
    version_id = api.version_id,
    search_method = "valid"
  ) => {
    const _this = this,
      params = { search_type, search_val, page, version_id, search_method };
    this.setState({ data_loading: true, page, version_id }, () => {
      params.name = params.search_val;
      app.post(api.HomeSearch, params).then(({ flag, data, msg, total }) => {
        if (flag === 1) {
          const resultList = [],
            search_type_str = _this.state.search_type_str;
          data.forEach((res) => {
            const obj = {
              name: res.vname,
              no: res.bsrno,
              localpath: res.portrait
                ? config.imgUrl + app.urlEncode(res.portrait)
                : default_head,
              indexno: res.indexno,
              team_id: res.team_id,
              identity: res.identity,
              uri: `/player/${res.team_id}/${res.volunteer_id}/?token=${_this.state.token}`,
              volunteer_id: res.volunteer_id,
              kx: null,
            };
            if (res.volunteer_state === "4") {
              obj.kx = "已离队";
            } else if (res.volunteer_state === "5") {
              obj.kx = "已清退";
            }
            resultList.push(obj);
          });

          _this.setState({
            data_loading: false,
            resultList,
            no_data:
              resultList.length > 0
                ? ""
                : NoData({ search_type_str, search_val }),
            total: isNaN(parseInt(total)) ? 0 : parseInt(total),
          });
        } else {
          app.alert(msg, "error");
        }
      });
    });
  };

  /**
   * 获取token
   * @returns {Promise<void>}
   */
  getTokeni = async (e) => {
    let that = this;

    let { flag, data, msg } = await app.post(api.getToken);

    if (flag === 1) {
      // if (data.token == e) {
      //     // that.handleLoading();
      that.setState({
        token: data.token,
      });
      // } else {
      //     // console.log("token无效，假证！");
      //     that.setState({
      //         isTrue: true,
      //         data_loading: false,
      //     });
      // }
    } else {
      app.alert(msg, "warn");
    }
  };

  getAdd = async (volunteer_id) => {};

  /**
   * 添加
   * @param id
   */
  handleDelete = async (res) => {
    const params = {
      account: app.getData("account"),
      user_id: res.volunteer_id,
      date: this.state.date,
      version_id: api.version_id,
    };
    let { flag, data, msg } = await app.post(api.dutyAdd, params);
    if (flag === 1) {
      let { onClose } = this.props;
      onClose(true);
    } else {
      app.alert(msg, "warn");
      let { onClose } = this.props;
      onClose(true);
    }
  };

  /**
   * 加载数据
   */
  handleLoading() {
    const _this = this;
    app.post(api.HomeClassList).then(({ flag, data, msg }) => {
      // _this.setState({ class_loading: false });
      if (flag === 1) {
        _this.setState({ classList: data });
      } else {
        app.alert(msg, "error");
      }
    });
  }

  handleMenuClick = (e) => {
    const search_type_str = e.item.props.children,
      search_type = e.key;
    this.setState({ search_type, search_type_str });
  };

  /**
   * 搜索
   * @returns {boolean}
   */
  handleSearch = async (value) => {
    let { search_val } = this.state;
    if (!value) {
      this.setState({ resultList: [] });
    } else {
      let { flag, data, msg } = await app.post(api.getToken);
      if (flag === 1) {
        const search_val = value;
        const search_type = this.state.search_type,
          search_val_flag = this.state.search_val_flag;
        this.dataSource(1, search_type, search_val);
        if (!search_val) {
          if (search_val_flag === false) {
            this.setState({ search_val_flag: true });
            const timer = setTimeout(() => {
              this.setState({ search_val_flag: false });
              clearTimeout(timer);
            }, 3000);
          }

          return false;
        }
      } else {
        this.setState({
          isTrue: true,
          data_loading: false,
        });
        app.alert(msg, "warn");
      }

      //     this.props.history.replace(`/search-result/${search_type}/${search_val}?token=${data.token}`);
      this.setState({ search_val: value });
      this.state.token = data.token;
      this.setState({
        token: data.token,
        isTrue: false,
        data_loading: false,
      });
    }
    // 在搜索页面点击搜索时也要获取一遍token
    // console.log();
    // this.props.history.replace(`/search-result/${search_type}/${search_val}/?token=${this.state.token}`);
  };

  /**
   * 分页修改
   */
  handlePageChage = (page) => {
    console.log(this.state.search_val);
    this.dataSource(page, this.state.search_type, this.state.search_val);
  };

  render() {
    const class_loading = this.state.class_loading,
      classList = this.state.classList,
      search_type_str = this.state.search_type_str,
      search_val = this.state.search_val,
      data_loading = this.state.data_loading,
      page = this.state.page,
      result_total = this.state.total,
      no_data = this.state.no_data,
      resultList = this.state.resultList || [],
      search_val_flag = this.state.search_val_flag,
      load_node = (
        <div className="loading">
          <Spin size="large" />
        </div>
      );
    return (
      <div className="search-result">
        <Layout>
          {/* <Header>
            <Head
              background="#3F89C1"
              height={100}
              history={this.props.history}
            />
          </Header> */}
          <Content>
            {/*<Row className="s_search">*/}
            <Input.Group
              className="s_search"
              compact
              style={{ borderRight: "none" }}
            >
              <Col span={6} style={{ height: "100%" }}>
                <Row
                  type="flex"
                  align="middle"
                  justify="space-around"
                  className="z_s"
                >
                  <span>{search_type_str}</span>
                </Row>
              </Col>
              <Col span={18} style={{ height: "100%" }}>
                {/* <Tooltip placement="bottomLeft" trigger="" visible={search_val_flag}> */}
                <Input.Search
                  size="large"
                  placeholder="请输入搜索内容"
                  onSearch={(value) => this.handleSearch(value)}
                  style={{ height: "100%" }}
                  defaultValue={search_val}
                  enterButton
                />
                {/* </Tooltip> */}
              </Col>
            </Input.Group>
            <div className="result-list">
              {data_loading
                ? load_node
                : resultList.length > 0
                ? resultList.map((res, index) => {
                    return (
                      <Col
                        key={index + 1}
                        className="item"
                        style={{ margin: "20px 0" }}
                      >
                        <Link to={res.uri}>
                          <div></div>
                          <div className="img">
                            <img src={res.localpath} alt="" />
                            {res.kx ? <div className="kx">{res.kx}</div> : null}
                          </div>
                          <p className="name">{res.name}</p>
                          <p className="num">{res.bottom_txt}</p>
                        </Link>
                        <Popconfirm
                          placement="bottom"
                          title="确定添加吗"
                          cancelText="取消"
                          okText="确定"
                          onConfirm={() => this.handleDelete(res)}
                        >
                          <Button type="primary">添加</Button>
                        </Popconfirm>
                      </Col>
                    );
                  })
                : no_data}
              {this.state.isTrue ? (
                <img
                  style={{
                    display: "block",
                    margin: "0 auto",
                    marginTop: "100px",
                  }}
                  src={this.state.img}
                  alt=""
                />
              ) : (
                ""
              )}
            </div>

            <Row className="page" type="flex" justify="center">
              <Pagination
                hideOnSinglePage
                showTotal={(total) => `总数：${total}`}
                current={page}
                showQuickJumper
                pageSize={20}
                total={result_total}
                onChange={this.handlePageChage}
              />
            </Row>
            {/* <div className="footer-list">
              <Foote />
              <ICP bg="#434343" />
            </div> */}
          </Content>
        </Layout>
      </div>
    );
  }
}

export default SearchResult;



// WEBPACK FOOTER //
// ./src/routes/grade/DutyAdd.jsx